// extracted by mini-css-extract-plugin
module.exports = {"form":"Password_form__1cQcy","buttonGroup":"Password_buttonGroup__26XSf","forgotten":"Password_forgotten__pS7TB"};